export const DEVELOPMENT_STATUSES = [
    'EF_EM_ELABORACAO',
    'EF_EM_VALIDACAO_IA',
    'EF_REJEITADA_IA',
    'EF_VALIDADA_IA',
    'AGUARDANDO_ATRIBUICAO_TECNICA',
    'EM_ANALISE_TECNICA',
    'AGUARDANDO_APROVACAO_ESTIMATIVA',
    'ESTIMATIVA_EM_REVISAO',
    'AGUARDANDO_INICIO',
    'EM_DESENVOLVIMENTO',
    'AGUARDANDO_REVISAO_DOCUMENTACAO',
    'EM_VALIDACAO_CONSULTOR',
    'EM_VALIDACAO_USUARIO_CHAVE',
    'COM_SOLICITACOES_PENDENTES',
    'IMPEDIDO',
    'ENCERRADO',
    'CANCELADO'
] as const;

export type DevelopmentStatus = (typeof DEVELOPMENT_STATUSES)[number];

export type RequestStatus = 'ABERTA' | 'APROVADA' | 'REJEITADA' | 'RESOLVIDA';
export type RequestType = 'BUG' | 'AJUSTE_MINOR';
export type Complexity = 'MUITO_BAIXA' | 'BAIXA' | 'MEDIA' | 'ALTA' | 'MUITO_ALTA';
export const DEVELOPMENT_CATEGORIES = ['NOVO', 'REMEDIADO', 'SIMPLIFICADO'] as const;
export type DevelopmentCategory = (typeof DEVELOPMENT_CATEGORIES)[number];
export type ProjectStatus = 'ATIVO' | 'INATIVO';
export type UserStatus = 'ATIVO' | 'BLOQUEADO';
export type UserProfile = 'ADM' | 'PMO' | 'CF' | 'GPA' | 'GPC' | 'LT' | 'DEV' | 'UC';
export type ReasonCategory = 'CANCELAMENTO' | 'REJEICAO_ESTIMATIVA' | 'REJEICAO_DOCUMENTACAO' | 'REJEICAO_SOLICITACAO' | 'DEVOLUCAO_EF' | 'AUMENTO_ESFORCO' | 'IMPEDIMENTO';

type StatusColor = 'default' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning';

const STATUS_BADGE_COLOR: Record<DevelopmentStatus, StatusColor> = {
    EF_EM_ELABORACAO: 'warning',
    EF_EM_VALIDACAO_IA: 'info',
    EF_REJEITADA_IA: 'error',
    EF_VALIDADA_IA: 'success',
    AGUARDANDO_ATRIBUICAO_TECNICA: 'warning',
    EM_ANALISE_TECNICA: 'secondary',
    AGUARDANDO_APROVACAO_ESTIMATIVA: 'warning',
    ESTIMATIVA_EM_REVISAO: 'warning',
    AGUARDANDO_INICIO: 'default',
    EM_DESENVOLVIMENTO: 'info',
    AGUARDANDO_REVISAO_DOCUMENTACAO: 'warning',
    EM_VALIDACAO_CONSULTOR: 'secondary',
    EM_VALIDACAO_USUARIO_CHAVE: 'primary',
    COM_SOLICITACOES_PENDENTES: 'error',
    IMPEDIDO: 'info',
    ENCERRADO: 'success',
    CANCELADO: 'default'
};

export function getStatusBadgeColor(status: string): StatusColor {
    return STATUS_BADGE_COLOR[status as DevelopmentStatus] ?? 'default';
}

export function getStatusLabelKey(status: string): string {
    return `statusLabels.${status}`;
}
